"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormView = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _vueJsonView = require("vue-json-view");

var _fieldType = require("../fieldType");

require("./index.less");

var _utils = require("../utils");

var _jsonComponent = require("../common/jsonComponent");

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getDataByName = _vueJsonView.Utils.getDataByName,
    setDataByObj = _vueJsonView.Utils.setDataByObj;
var FormView = (_dec = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return {};
  }
}), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: 'add'
}), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec5 = (0, _vuePropertyDecorator.Watch)('data', {
  immediate: true
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(FormView, _Mixins);

  var _super = _createSuper(FormView);

  function FormView() {
    var _this;

    (0, _classCallCheck2.default)(this, FormView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "mode", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "handleSubmit", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "extraProps", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    _this.formData = {};
    return _this;
  }

  (0, _createClass2.default)(FormView, [{
    key: "type",
    get: function get() {
      return this.mode !== 'view' ? 'form' : 'view';
    }
  }, {
    key: "columns",
    get: function get() {
      return _fieldType.FieldType.trans2TreeByType(this.formItems);
    }
  }, {
    key: "dataChange",
    value: function dataChange(data) {
      this.formData = data;
    }
  }, {
    key: "doSubmit",
    value: function doSubmit() {
      var _this2 = this;

      var form = this.$refs.form;

      if (form && form.doSubmit) {
        form.doSubmit( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // 过滤所有数组中的 null
                    _this2.formItems.forEach(function (item) {
                      var _item$_type;

                      if (((_item$_type = item._type) === null || _item$_type === void 0 ? void 0 : _item$_type.type) === 'spreadArray' && values[item.name]) {
                        var _this2$data, _this2$data$item$name;

                        values[item.name]._id = (_this2$data = _this2.data) === null || _this2$data === void 0 ? void 0 : (_this2$data$item$name = _this2$data[item.name]) === null || _this2$data$item$name === void 0 ? void 0 : _this2$data$item$name._id;
                      }
                    });

                    return _context.abrupt("return", _this2.handleSubmit(_objectSpread(_objectSpread({}, _this2.data), (0, _utils.filterNullList)(values))));

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    } // 获取摘要

  }, {
    key: "getSummary",
    value: function getSummary(data) {
      var _this3 = this;

      var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.columns;
      return columns.filter(function (item) {
        if (_this3.formProperty._summary && _this3.formProperty._summary.length) {
          return _this3.formProperty._summary.includes(item.dataIndex || item.key);
        }

        return true;
      }).map(function (item) {
        var key = item.dataIndex || item.key;
        var currentData = key ? getDataByName(data, key) : data;
        var children = item.customRender ? item.customRender(currentData, data) : currentData;

        if ((0, _typeof2.default)(children) !== 'object' && item.title) {
          return "".concat(item.title, ": ").concat(children || '-');
        }
      }).filter(function (i) {
        return i;
      }).join('\r\n');
    }
  }, {
    key: "renderTable",
    value: function renderTable(list, data, fullData) {
      var _this4 = this;

      var h = this.$createElement;
      var titles = list.map(function (item) {
        return h("th", [h("div", [item.title])]);
      });
      var lines = [];

      if (Array.isArray(data)) {
        data.forEach(function (item) {
          var out = list.map(function (line) {
            var currentData = getDataByName(item, line.dataIndex);
            var children = line.customRender ? _vueJsonView.VueJsonView.ele2VNode(_this4.$createElement, line.customRender(currentData, fullData), _this4.data) : currentData;
            return h("td", [h("div", [children])]);
          });
          lines.push(h("tr", [out]));
        });
      }

      return h("div", {
        "class": "form-view-item-content"
      }, [h("div", {
        "class": "form-view-table"
      }, [h("table", [h("tr", [titles]), lines])]), lines.length === 0 && h("div", {
        "class": "form-table-empty"
      }, ["\u6682\u65E0\u6570\u636E"])]);
    }
  }, {
    key: "renderDetail",
    value: function renderDetail(formItems, data) {
      var _this5 = this;

      var h = this.$createElement;
      var renderTable = this.renderTable;
      var items = formItems.map(function (item) {
        var _item$_type2, _item$_type4;

        var text;
        var classNames = {
          'form-view-item-wrapper': true
        };
        var currentData = item.name && getDataByName(data, item.name);

        if (item.tag === 'mh-json-view') {
          return _vueJsonView.VueJsonView.ele2VNode(_this5.$createElement, item);
        }

        if ((item === null || item === void 0 ? void 0 : (_item$_type2 = item._type) === null || _item$_type2 === void 0 ? void 0 : _item$_type2.type) === 'objectArray') {
          var _item$_type3;

          // 子表单
          var children = getDataByName(item, ((_item$_type3 = item._type) === null || _item$_type3 === void 0 ? void 0 : _item$_type3.path) || '') || [];
          classNames['form-view-item-table'] = true;
          text = renderTable(_fieldType.FieldType.trans2TreeByType(children), currentData, data);
        } else if ((item === null || item === void 0 ? void 0 : (_item$_type4 = item._type) === null || _item$_type4 === void 0 ? void 0 : _item$_type4.type) === 'spreadArray') {
          var _item$_type5;

          // 关联表
          var _children = getDataByName(item, ((_item$_type5 = item._type) === null || _item$_type5 === void 0 ? void 0 : _item$_type5.path) || '') || [];

          return _this5.renderDetail(_children, currentData);
        } else if (item !== null && item !== void 0 && item._type) {
          // 其他
          var col = _fieldType.FieldType.trans2TreeByType([item])[0] || {};

          var _children2 = col.customRender ? _vueJsonView.VueJsonView.ele2VNode(_this5.$createElement, col.customRender(currentData, currentData), data) : currentData;

          text = h("div", {
            "class": "form-view-item-text"
          }, [h("div", [_children2 || '-'])]);
        } else {
          return _vueJsonView.VueJsonView.ele2VNode(_this5.$createElement, item);
        }

        return h("div", {
          "class": classNames
        }, [h("div", {
          "class": "form-view-item"
        }, [h("div", {
          "class": "form-view-item-label"
        }, [h("label", [item.label])]), text])]);
      });
      return h("div", {
        "class": "form-view"
      }, [h("div", {
        "class": "form-view-items"
      }, [items])]);
    }
  }, {
    key: "renderEditFormItem",
    value: function renderEditFormItem(item, data) {
      var _this6 = this,
          _obj$_type;

      var h = this.$createElement;
      var mode = this.mode,
          columns = this.columns,
          formData = this.formData,
          _this$extraProps = this.extraProps,
          extraProps = _this$extraProps === void 0 ? {} : _this$extraProps; // 覆盖初始值

      var obj = _objectSpread(_objectSpread({}, item), {}, {
        options: item.options ? _objectSpread(_objectSpread({}, item.options), {}, {
          initData: _vueJsonView.Utils.getDataByName(data, item.name) || item.options.initData
        }) : {}
      });

      if (obj.children && (0, _typeof2.default)(obj.children) === 'object') {
        obj.children = _objectSpread(_objectSpread({}, item.children), extraProps);
      } // 不可编辑


      if (obj._notEditable && mode === 'edit' || obj._valueNotEditable && getDataByName(data, obj.name)) {
        var _item$_type6;

        if ((item === null || item === void 0 ? void 0 : (_item$_type6 = item._type) === null || _item$_type6 === void 0 ? void 0 : _item$_type6.type) === 'objectArray') {
          var _item$_type7;

          var children = getDataByName(item, ((_item$_type7 = item._type) === null || _item$_type7 === void 0 ? void 0 : _item$_type7.path) || '') || [];
          var currentData = getDataByName(data, obj.name);
          return h("div", {
            "class": "form-view-item-table"
          }, [h("div", {
            "class": "form-view-item"
          }, [h("div", {
            "class": "form-view-item-label"
          }, [h("label", [item.label])]), this.renderTable(_fieldType.FieldType.trans2TreeByType(children), currentData, data)])]);
        } else {
          var config = columns.find(function (col) {
            return col.dataIndex === obj.name;
          });

          if (config !== null && config !== void 0 && config.customRender && typeof config.customRender === 'function') {
            obj.children = config.customRender(getDataByName(data, obj.name), data);
          } else {
            var value = getDataByName(data, obj.name);
            obj.children = typeof value === 'number' ? value + '' : value;
          }
        }
      } // 扩展 Array


      if (obj._componentName === 'linktable' && obj.link) {
        var showFields = obj.link.showFields || [];
        return showFields.map(function (field) {
          return _this6.renderEditFormItem(_objectSpread(_objectSpread({}, field), {}, {
            name: obj.name + '.' + field.name
          }), data);
        });
      } // 子表单


      if (((_obj$_type = obj._type) === null || _obj$_type === void 0 ? void 0 : _obj$_type.type) === 'objectArray') {
        var _Utils$getDataByName;

        (_Utils$getDataByName = _vueJsonView.Utils.getDataByName(obj, obj._type.path)) === null || _Utils$getDataByName === void 0 ? void 0 : _Utils$getDataByName.forEach(function (child) {
          if (child.children && (0, _typeof2.default)(child.children) === 'object') {
            child.children = _objectSpread(_objectSpread({}, child.children), extraProps);
          }
        });
      }

      return _vueJsonView.VueJsonView.ele2VNode(this.$createElement, obj, formData);
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this7 = this;

      var formProperty = this.formProperty,
          data = this.data,
          mode = this.mode,
          renderDetail = this.renderDetail,
          formItems = this.formItems,
          handleSubmit = this.handleSubmit,
          formData = this.formData;

      if (mode === 'view') {
        return renderDetail(this.formItems, this.data);
      }

      var items = formItems.map(function (item) {
        return _this7.renderEditFormItem(item, data);
      });
      return h("mh-form", {
        "attrs": {
          "initData": data,
          "hanleSubmit": handleSubmit
        },
        "on": {
          "itemChange": function itemChange(item) {
            _this7.$emit('itemChange', item);

            _this7.formData = setDataByObj(formData, item);
          }
        },
        "ref": "form",
        "props": _objectSpread({}, _objectSpread(_objectSpread({}, formProperty), {}, {
          children: undefined
        }))
      }, [items]);
    }
  }]);
  return FormView;
}((0, _vuePropertyDecorator.Mixins)(_jsonComponent.JsonComponent)), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "mode", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "handleSubmit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "extraProps", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "dataChange", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "dataChange"), _class2.prototype)), _class2)) || _class);
exports.FormView = FormView;